import { useQuery } from "@tanstack/react-query";
import { fetchCustomerCounterOffer } from "../services/api/offers";

// Whether the customer has accepted a client's counter offer (proposal) on this work
// order. The agreed payment is then final for them: rates and expenses lock and only
// the purchase order stays editable. An accepted proposal is stored as ASSIGNED; the
// history is checked too, so a later proposal from the client doesn't unlock it.
// Shares the "customerCounterOffer" query with the Proposals tab and the banners.
export const useHasAcceptedProposal = (workOrderId, enabled = true) => {
  const { data } = useQuery({
    queryKey: ["customerCounterOffer", Number(workOrderId)],
    queryFn: () => fetchCustomerCounterOffer(workOrderId),
    enabled: !!workOrderId && enabled,
  });
  const offer = data?.data;
  return (
    !!offer &&
    (offer.status === "ASSIGNED" ||
      (offer.offerHistory || []).some((row) => row.status === "ASSIGNED"))
  );
};
